module.exports = __webpack_public_path__ + "media/images/browser-4ece914eb85cc6c6f294d52372c5fc30.svg";